import React, { useState, useMemo } from 'react';
import WeatherData from '../../../core/WeatherData';
import { ResponsiveContainer, LineChart, YAxis, XAxis, Tooltip, Line } from 'recharts';

interface TemperatureChart {
    weatherData: WeatherData
}

const TemperatureChartComponent: React.FC<TemperatureChart> = ({ weatherData }) => {
    const temperatures = weatherData.getTemperatureHistory();
    
    const formatTick = useMemo(() => {
        return (index: number) => {
            const d = temperatures[index].getDate();
            const prefix = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
            return `${prefix} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        };
    }, [temperatures]);
    const chartData = temperatures.map((t, i) => { 
        return { x: formatTick(i), temp: t.getTemperature() };
    });
    return (
        <ResponsiveContainer width="100%" height={152}>
            <LineChart data={chartData} margin={{top: 5, bottom: 5}}>
                <XAxis dataKey="x" tick={{fontSize: 10 }} angle={-20} textAnchor='end' tickFormatter={(value: string) => value.substring(5)} />
                <YAxis tick={{fontSize: 12 }} domain={[(dataMin) => Math.floor(dataMin) - 0.5, 'dataMax']} interval={'preserveStartEnd'}/>
                <Tooltip formatter={(value: number) => [`${value.toFixed(1)} ºC`, 'Temp']} cursor={{ fill: 'transparent' }} />
                <Line dataKey="temp" fill={'orange'} stroke={'orange'} dot={false} />
            </LineChart>
        </ResponsiveContainer>
    )
}

export default TemperatureChartComponent;
